import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import * as React from "react";
import styled, { css } from "styled-components";
export var Container = function(props) {
    var layoutElement = React.useContext(Context).layoutElement;
    return /*#__PURE__*/ _jsx(ContainerWrapper, {
        $backgroundColor: layoutElement.background_color,
        $textColor: layoutElement.main_text_color,
        className: props.className,
        children: props.children
    });
};
var ContainerWrapper = styled.div.withConfig({
    componentId: "sc-72f7713c-0"
})([
    "",
    ""
], function(param) {
    var $backgroundColor = param.$backgroundColor, $textColor = param.$textColor;
    return css([
        "background-color:",
        ";color:",
        ";"
    ], $backgroundColor !== null && $backgroundColor !== void 0 ? $backgroundColor : "transparent", $textColor !== null && $textColor !== void 0 ? $textColor : Core.text.enabled);
});
